import script from "./Lifestyle-personal-history.vue?vue&type=script&setup=true&lang=js"
export * from "./Lifestyle-personal-history.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__